import React, { FunctionComponent } from "react";
import { IProps, QRCode } from "react-qrcode-logo";
import Colours from "../../../utils/colours";
import logo from "../../../public/images/AllBrightA.png";

const RxQrCode: FunctionComponent<IProps> = (props) => {
  const size = props.size || 230;
  const logoWidth = size / 2;
  const logoHeight = logoWidth * 0.7;

  return (
    <QRCode
      style={{ margin: "0 auto" }}
      size={size}
      bgColor={Colours.black}
      fgColor={Colours.shell}
      logoImage={logo.src}
      logoWidth={logoWidth}
      logoHeight={logoHeight}
      qrStyle={"dots"}
      {...props}
    />
  );
};

export default RxQrCode;
